import { IDoneFunctions, ITranslatedField } from '../interfaces';
import { instances } from '../core/axios';
import { refreshWithRequest } from '../helpers/refresh-with-request';

export interface IDictionaryPayload {
  field_key: string;
  value: ITranslatedField;
}

export const dictionariesService = {
  async getOne(id: string, done?: IDoneFunctions) {
    try {
      return await instances.commonInstance.get(`dictionaries/${id}`);
    } catch (e) {
      done?.failure();
    }
  },

  async createOne(payload: IDictionaryPayload, done?: IDoneFunctions) {
    try {
      await instances.commonInstance.post('dictionaries', payload);
      done?.success();
    } catch (e: any) {
      if (e.response.status === 401) {
        refreshWithRequest({
          onSuccess: (data) => {
            return instances.commonInstance
              .post(`dictionaries`, payload, {
                headers: {
                  Authorization: `Bearer ${data.access_token}`,
                },
              })
              .then(() => {
                document.location.href = `${document.location.origin}/#/dictionaries`;
              });
          },
        });
      }
      done?.failure(e);
    }
  },

  async updateOne(
    id: string,
    payload: IDictionaryPayload,
    done?: IDoneFunctions,
  ) {
    try {
      await instances.commonInstance.patch(`dictionaries/${id}`, payload);
      done?.success();
    } catch (e: any) {
      if (e.response.status === 401) {
        refreshWithRequest({
          onSuccess: (data) => {
            return instances.commonInstance
              .patch(`dictionaries/${id}`, payload, {
                headers: {
                  Authorization: `Bearer ${data.access_token}`,
                },
              })
              .then(() => {
                document.location.href = `${document.location.origin}/#/dictionaries`;
              });
          },
        });
      }
      done?.failure();
    }
  },
};
